export const useJsonldWebPageForProductLP = (
  url: MaybeRefOrGetter<string>,
  title: MaybeRefOrGetter<string>,
  description: MaybeRefOrGetter<string>,
  dateModified: MaybeRefOrGetter<string>
) =>
  useJsonld(
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      '@id': `${toValue(url)}#WebPage`,
      url: toValue(url),
      inLanguage: 'ja',
      name: toValue(title),
      dateModified: toValue(dateModified),
      description: toValue(description),
      reviewedBy: [],
    },
    {
      tagPosition: 'bodyClose',
    }
  );
